import React from 'react';

const FlatPanel = (props) => {

    return (
        <div className="flat-panel" {...props}>
            <div className="panel">
                {props.children}
            </div>
            <div className="panel" />
            <div className="panel" />
        </div>
    );

};
export default FlatPanel;


// WEBPACK FOOTER //
// ./src/js/components/FlatPanel.js